/// <amd-module name="Wit/DeliveryPlans/Common/Utils/TelemetryUtils" />

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export namespace TelemetryConstants {
    export const Area = "DeliveryPlans2";

    // CI Features
    export const PlanCreated = "PlanCreated";
    export const PlanViewed = "PlanViewed";

    // Property keys
    export const TeamCount = "TeamCount";
}

export function publishTelemetry(pageContext: IVssPageContext, featureName: string, properties: { [key: string]: string } = {}): void {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    telemetryService.publishEvent(TelemetryConstants.Area, featureName, properties);
}
